// extracted by mini-css-extract-plugin
export var goalContainer = "about-module--goalContainer--RNzoa";
export var goalImage = "about-module--goalImage--2B174";
export var certificatesContainer = "about-module--certificatesContainer--1z7UA";
export var certificate = "about-module--certificate--3fDXA";
export var lightbox = "about-module--lightbox--I-Pvw";